import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { JsonViewerComponent } from 'shared/components/json-viewer/json-viewer.component';

@Component({
  selector: 'app-validation-error-details-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatTabsModule,
    MatTooltipModule,
    ClipboardModule,
    MatSnackBarModule,
    JsonViewerComponent
  ],
  templateUrl: './validation-error-details-dialog.component.html',
  styleUrls: ['./validation-error-details-dialog.component.scss']
})
export class ValidationErrorDetailsDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ValidationErrorDetailsDialogComponent>,
    private snackBar: MatSnackBar
  ) {}

  get formattedJson(): string {
    return this.data.documentJson 
      ? JSON.stringify(this.data.documentJson, null, 2)
      : '';
  }

  copyJsonToClipboard(): void {
    if (this.formattedJson) {
      navigator.clipboard.writeText(this.formattedJson).then(() => {
        this.snackBar.open('JSON skopiowany do schowka', 'OK', {
          duration: 3000
        });
      });
    }
  }

  copyErrorToClipboard(): void {
    const errorText = JSON.stringify(this.data.error, null, 2);
    navigator.clipboard.writeText(errorText).then(() => {
      this.snackBar.open('Błąd skopiowany do schowka', 'OK', {
        duration: 3000
      });
    });
  }

  copyAllForAI(): void {
    const prompt = `Cześć! Mam problem z walidacją faktury w systemie KSeF (Krajowy System e-Faktur) dla schematu FA(3) v1-0E.

**Błąd walidacji:**
\`\`\`json
${JSON.stringify(this.data.error, null, 2)}
\`\`\`

**JSON faktury:**
\`\`\`json
${this.formattedJson}
\`\`\`

**Pytanie:**
Dlaczego ta faktura nie przeszła walidacji KSeF FA(3)? Co jest nie tak z danymi i jak to naprawić?`;

    navigator.clipboard.writeText(prompt).then(() => {
      this.snackBar.open('✅ Skopiowano błąd + JSON + prompt do AI', 'OK', {
        duration: 4000
      });
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}

